import { render, staticRenderFns } from "./ViqExpansionOpportunity.vue?vue&type=template&id=0a4a4e56&scoped=true"
import script from "./ViqExpansionOpportunity.vue?vue&type=script&lang=js"
export * from "./ViqExpansionOpportunity.vue?vue&type=script&lang=js"
import style0 from "./ViqExpansionOpportunity.vue?vue&type=style&index=0&id=0a4a4e56&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a4e56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4a4e56')) {
      api.createRecord('0a4a4e56', component.options)
    } else {
      api.reload('0a4a4e56', component.options)
    }
    module.hot.accept("./ViqExpansionOpportunity.vue?vue&type=template&id=0a4a4e56&scoped=true", function () {
      api.rerender('0a4a4e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqExpansionOpportunity.vue"
export default component.exports